export default {
    ACTIVE: 'ACTIVE',
    INVALID: 'INVALID',
};
